import { Button, Flex, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';

import Icon from 'utils/icon';
import PageTitle from 'components/title/title';
import logo from 'assets/images/logo-dark.svg';
import { useState, useEffect } from 'react';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import authService from 'core/services/auth';
import { onCheckInvoice } from 'core/services/payments';
import { getViewerWidth } from 'utils/fileViewerWidth';

import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

const { useBreakpoint } = Grid;

function PaymentCheckComponent() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const screens = useBreakpoint();
	const [searchParams] = useSearchParams();

	const reference = searchParams.get('reference');

	const [isLoading, setIsLoading] = useState(true);
	const [isExist, setIsExist] = useState(false);

	const [url, setUrl] = useState<string>();
	const [numOfPages, setNumOfPages] = useState<number>(0);
	const [containerWidth, setContainerWidth] = useState<number>(getViewerWidth());

	useEffect(() => {
		checkPayment();

		const handleResize = () => {
			setContainerWidth(getViewerWidth());
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const checkPayment = async () => {
		try {
			const response = await onCheckInvoice(reference!);
			setUrl(response.download_url);
			setIsLoading(false);
			setIsExist(true);
		} catch (error) {
			setIsLoading(false);
			setIsExist(false);
		}
	};

	const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
		setNumOfPages(numPages);
	};

	return (
		<>
			<PageTitle name={t('TITLE.PAYMENT_CHECK')} />

			<Flex vertical style={{ height: '100vh' }}>
				<img src={logo} alt="logo" style={{ width: 200, margin: 20 }} />

				<Flex vertical={!screens.md} flex={1} justify="center" align="center" style={{ marginTop: -100, padding: 20, width: '100vw' }}>
					<motion.div layout style={{ flex: 1 }}>
						{isLoading ? (
							<LoadingComponent />
						) : isExist ? (
							<motion.div style={{ width: 100, margin: 'auto' }} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
								<Icon name="success2" width={100} height={100} />
							</motion.div>
						) : (
							<motion.div style={{ width: 100, margin: 'auto' }} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
								<Icon name="failed2" width={100} height={100} />
							</motion.div>
						)}
						<h3 className="my-3 text-center">
							{isLoading ? t('COMMON.CHECKING_PAYMENT') : isExist ? t('COMMON.PAYMENT_EXIST') : t('COMMON.PAYMENT_NOT_EXIST')}
						</h3>

						{!isLoading && (
							<motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}>
								<Button
									style={{ margin: '30px auto', display: 'block' }}
									type="primary"
									onClick={() => (authService.token ? navigate('/dashboard') : navigate('/'))}>
									{t('LOGIN.HOME')}
								</Button>
							</motion.div>
						)}
					</motion.div>

					{!isLoading && isExist && (
						<motion.div
							style={{
								width: 900,
								maxWidth: '100%',
								height: 'calc(100vh - 50px)',
								borderRadius: 10,
								border: '1px solid #ddd',
								overflow: 'hidden',
							}}
							initial={{ opacity: 0, x: 80 }}
							animate={{ opacity: 1, x: 0 }}
							exit={{ opacity: 0 }}
							transition={{ duration: 0.6, delay: 0.5 }}>
							<Document file={url} onLoadSuccess={onDocumentLoadSuccess} className="agreementPdf">
								{Array.from({ length: numOfPages }, (_, i) => (
									<Page pageNumber={i + 1} scale={1} width={containerWidth} key={i} />
								))}
							</Document>
						</motion.div>
					)}
				</Flex>
			</Flex>
		</>
	);
}

export default PaymentCheckComponent;
